import { render, staticRenderFns } from "./LogType.vue?vue&type=template&id=6dd56184&"
import script from "./LogType.vue?vue&type=script&lang=js&"
export * from "./LogType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports